import React, { Dispatch, useState } from "react";
import { CloseIcon } from "../iconSet/IconSet";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export type MultiDragDropUploadPropsTypes = {
  label: string;
  files: File[];
  setFile: Dispatch<React.SetStateAction<File[]>>;
  folderId : string;
  onImageClick?: (url: string) => void;
  setFileFun: (newFiles: File[]) => void
};

const MultipleDragDropUpload = (props: MultiDragDropUploadPropsTypes) => {
  const [isDragging, setIsDragging] = useState<boolean>(false);

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    if (e.dataTransfer.files) {
      const droppedFiles = Array.from(e.dataTransfer.files);
      props.setFile((prevFiles) => [...prevFiles, ...droppedFiles]);
    }
  };

  const handleFileInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const selectedFiles = Array.from(e.target.files);
      props.setFileFun(selectedFiles);
    }
  };

  const handleCloseFile = (fileName: string) => {
    props.setFile((prevFiles) => prevFiles.filter((f) => f.name !== fileName));
  };

  const isImageFile = (fileName: string) => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp"];
    const ext = fileName.split(".").pop()?.toLowerCase();
    return ext && imageExtensions.includes(ext);
  };

  return (
    <div className="drag-drop-upload-wrapper">
      <span>{props.label}</span>
      <div
        className="drag-drop-upload"
        onDragOver={handleDragOver}
        onDragEnter={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        style={{
          backgroundColor: isDragging
            ? "rgba(var(--color-main-black), 0.05)"
            : "var(--color-container-drag-bg)",
            height: 'fit-content'
        }}
      >
        <p>Drag and drop files here, or click to select files</p>
        <input type="file" multiple onChange={handleFileInput} id="fileInput" />
        <label htmlFor="fileInput">Browse Files</label>

        {props.files.length > 0 && (
          <div
            className="upload-file-wrapper"
            style={{
              maxHeight: "150px",
              overflow: 'hidden',
              overflowY: "auto",
              border: "1px solid var(--color-border)",
              padding: "0.5rem",
              borderRadius: "4px",
              background: "var(--color-container-drag-bg)",
              display: 'flex',
              minHeight: '5rem',
              gap: '0.5rem',
              flexWrap: 'wrap'
            }}
          >
            {props.files.map((file, index) => {
              const isFileObject = file instanceof File;
              const isImage = isImageFile(file.name);

              const localPreview = isFileObject
                ? URL.createObjectURL(file)
                : null;
              const backendImageUrl = `${BASE_URL}/static_resource/api/v1/files/RPCUPLOADS/${
                props.folderId
              }/${file.name.trim()}`;

              const imageUrl = localPreview || backendImageUrl;

              return (
                <div
                  key={index}
                  className="uploaded-file"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "4px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      cursor: "pointer"
                    }}
                    onClick={() =>
                      /* isImageFile(file.name) && */ props.onImageClick?.(imageUrl)
                    }
                  >
                    {isImage && (
                      <img
                        src={imageUrl}
                        alt={file.name}
                        style={{
                          width: "40px",
                          height: "40px",
                          objectFit: "cover",
                          borderRadius: "4px",
                        }}
                        onError={(e) => {
                          (e.target as HTMLImageElement).style.display = "none";
                        }}
                      />
                    )}
                    <span>{file.name}</span>
                  </div>

                  <div
                    onClick={() => handleCloseFile(file.name)}
                    style={{ cursor: "pointer", marginLeft: "8px" }}
                  >
                    <CloseIcon width="1rem" color="var(--color-main-red)" />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default MultipleDragDropUpload;